// import React from "react";
// import "./Address.scss";

// export function Address() {
//     return (
//         <div className="addressDesktop-base-addressLayout">
//             <div className="addressDesktop-base-left">
//                 <div className="addressDesktop-base-addAddressContainer">
//                     <div className="addressFormUI-base-container">
//                         <div className="addressFormUI-base-scrollable">
//                             <div className="addressFormUI-base-formHeader">CONTACT DETAILS</div>
//                             <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
//                                 <div className="inputV2-base-inputRow addressFormUI-base-inputRow">
//                                     <input className=" inputV2-base-input " id="name" type="text" placeholder="Name*" />
//                                 </div>
//                                 <div className="inputV2-base-inputRow ">
//                                     <input
//                                         className=" inputV2-base-input "
//                                         id="mobile"
//                                         type="tel"
//                                         placeholder="Mobile No*"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="addressFormUI-base-formHeader">ADDRESS</div>
//                             <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
//                                 <div className="addressFormUI-base-pincodeBlock">
//                                     <div className="addressFormUI-base-inputContainer">
//                                         <div className="inputV2-base-inputRow  inputV2-base-top">
//                                             <input
//                                                 className=" inputV2-base-input "
//                                                 id="pincode"
//                                                 type="tel"
//                                                 placeholder="Pin Code*"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="inputV2-base-inputRow addressFormUI-base-inputRow">
//                                     <input
//                                         className=" inputV2-base-input "
//                                         id="streetAddress"
//                                         type="text"
//                                         placeholder="Address (House No, Building, Street, Area)*"
//                                     />
//                                 </div>
//                                 <div className="addressFormUI-base-cityContainer">
//                                     <div className="inputV2-base-inputRow addressFormUI-base-halfWidth inputV2-base-top">
//                                         <input
//                                             className=" inputV2-base-input "
//                                             id="city"
//                                             type="text"
//                                             placeholder="city"
//                                         />
//                                     </div>
//                                     <div className="inputV2-base-inputRow addressFormUI-base-halfWidth inputV2-base-top">
//                                         <input
//                                             className=" inputV2-base-input "
//                                             id="state"
//                                             type="text"
//                                             placeholder="state"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="addressFormUI-base-formHeader">SAVE ADDRESS AS</div>
//                             <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
//                                 <div className="addressFormUI-base-addressTypes">
//                                     <div
//                                         className="addressFormUI-base-addressTypeIcon addressFormUI-base-selectedAddressType"
//                                         id="addressType-home"
//                                         data-value="HOME"
//                                     >
//                                         Home
//                                     </div>
//                                     <div
//                                         className="addressFormUI-base-addressTypeIcon "
//                                         id="addressType-office"
//                                         data-value="OFFICE"
//                                     >
//                                         Work
//                                     </div>
//                                     <div className="addressFormUI-base-error"></div>
//                                 </div>
//                             </div>
//                             <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
//                                 <div
//                                     className="addressFormUI-base-isDefault"
//                                     id="isDefault-icon"
//                                     data-value="undefined"
//                                 >
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="16"
//                                         height="16"
//                                         viewBox="0 0 16 16"
//                                     >
//                                         <path
//                                             fill-rule="nonzero"
//                                             d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
//                                         ></path>
//                                     </svg>
//                                     <span className="addressFormUI-base-defaultAddress">
//                                         Make this my default address
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="addressFormUI-base-footer">
//                             <div
//                                 data-testid="button"
//                                 className="button-base-button addressFormUI-base-saveBtn  button-base-textTransform"
//                             >
//                                 ADD ADDRESS
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }











import React, { useState, useEffect } from "react";
import "./Address.scss";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "../Contexts/ToastContext";

export function AddAddress() {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [searchParams] = useSearchParams();
    const editId = searchParams.get("edit") || null;

    const [addressList, setAddressList] = useState([]);
    const [addressLoading, setAddressLoading] = useState(true);
    const [editingAddressId, setEditingAddressId] = useState(null);
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [deletingAddress, setDeletingAddress] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        pincode: "",
        streetAddress: "",
        city: "",
        state: "",
        addressType: "HOME",
        isDefault: false,
    });

    const mobilePattern = /^\d{10}$/;
    const pincodePattern = /^[1-9][0-9]{5}$/;

    const [errorData, setErrorData] = useState({
        mobile: false,
        pincode: false
    })
    
    const [submitClicked, setSubmitClicked] = useState(false)

    console.log('errorData - ', errorData);


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        console.log('in handleInputChange - ', id, ' - ', value);

        if (submitClicked && id == "mobile") {
            if (mobilePattern.test(value)) {
                setErrorData({...errorData, mobile: false})
            }
            else {
                setErrorData({...errorData, mobile: true})
            }
        }
        else if (submitClicked && id == "pincode") {
            if (pincodePattern.test(value)) {
                setErrorData({...errorData, pincode: false})
            }
            else {
                setErrorData({...errorData, pincode: true})
            }
        }
        setFormData((prevData) => ({ ...prevData, [id]: value }));
    };

    const handleAddressTypeChange = (type) => {
        setFormData((prevData) => ({ ...prevData, addressType: type }));
    };

    const toggleDefaultAddress = () => {
        setFormData((prevData) => ({ ...prevData, isDefault: !prevData.isDefault }));
    };

    const fetchAddresses = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            setAddressLoading(false);
            return;
        }
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await axios.get('/address/get-all', config);
            setAddressList(response.data || []);
        } catch (err) {
            console.error('Error fetching addresses:', err);
        } finally {
            setAddressLoading(false);
        }
    };

    useEffect(() => {
        fetchAddresses();
    }, []);

    // Populate form when editing (edit=id in URL and address list loaded)
    useEffect(() => {
        if (!editId || !addressList.length) return;
        const addr = addressList.find((a) => a._id === editId || String(a._id) === editId);
        if (addr) {
            setFormData({
                name: addr.name || "",
                mobile: addr.mobile || "",
                pincode: addr.pincode != null ? String(addr.pincode) : "",
                streetAddress: addr.streetAddress || "",
                city: addr.city || "",
                state: addr.state || "",
                addressType: addr.addressType === "OFFICE" ? "OFFICE" : "HOME",
                isDefault: !!addr.isDefault,
            });
            setEditingAddressId(addr._id);
        }
    }, [editId, addressList]);

    const openDeleteConfirmModal = () => setShowDeleteConfirmModal(true);
    const closeDeleteConfirmModal = () => !deletingAddress && setShowDeleteConfirmModal(false);

    const handleConfirmDeleteAddress = async () => {
        if (!editingAddressId) return;
        const token = localStorage.getItem("token");
        if (!token) return;
        setDeletingAddress(true);
        try {
            await axios.delete(`/address/${editingAddressId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            closeDeleteConfirmModal();
            setEditingAddressId(null);
            navigate("/order-summary");
        } catch (err) {
            console.error("Error deleting address:", err);
            showToast({ message: err.response?.data?.message || "Failed to delete address." });
        } finally {
            setDeletingAddress(false);
        }
    };

    const handleSubmit = async () => {
        console.log("Form Data:", formData);

        setSubmitClicked(true)

        // Validate required fields
        if (!formData.name || !formData.mobile || !formData.pincode || !formData.streetAddress) {
            showToast({ message: "Please fill in all required fields" });
            return;
        }

        if (!mobilePattern.test(formData.mobile)) {
            setErrorData((prev) => {
                return { ...prev, mobile: true }
            })
            return;
        }

        if (!pincodePattern.test(formData.pincode)) {
            setErrorData((prev) => {
                return { ...prev, pincode: true }
            })
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = {
                name: formData.name,
                mobile: formData.mobile,
                pincode: formData.pincode,
                streetAddress: formData.streetAddress,
                city: formData.city,
                state: formData.state,
                addressType: formData.addressType,
                isDefault: formData.isDefault
            };

            if (editingAddressId) {
                await axios.patch(`/address/${editingAddressId}`, payload, config);
            } else {
                await axios.post("/address/create", payload, config);
            }
            navigate("/order-summary");
        } catch (error) {
            console.error("Error saving address:", error);
            const errorMessage = error.response?.data?.message || error.message || "Failed to save address. Please try again.";
            showToast({ message: errorMessage });
        }
    };

    return (
        <>
            {/* <div className="checkout-steps-container design-1">
                <div className="checkout-steps">
                    <div className="step completed">
                        <div className="step-label">BAG</div>
                        <div className="step-line"></div>
                    </div>
                    <div className="step active">
                        <div className="step-label">ADDRESS</div>
                        <div className="step-line"></div>
                    </div>
                    <div className="step">
                        <div className="step-label">PAYMENT</div>
                        <div className="step-line"></div>
                    </div>
                </div>
            </div> */}
            <div className="address-page-header design-2">
                <div className="address-page-title">
                    <h1>Delivery Address</h1>
                    <p>Add your delivery details to complete your order</p>
                </div>
            </div>
            <div className="addressDesktop-base-addressLayout">
                <div className="addressDesktop-base-left">
                    <div className="addressDesktop-base-addAddressContainer">
                        <div className="addressFormUI-base-container">
                            <div className="addressFormUI-base-scrollable">
                                <div className="addressFormUI-base-formHeader contact-details-header">CONTACT DETAILS</div>
                                <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
                                    <div className="inputV2-base-inputRow addressFormUI-base-inputRow">
                                        <label htmlFor="name" className="input-label">Name *</label>
                                        <input
                                            className="inputV2-base-input"
                                            id="name"
                                            type="text"
                                            placeholder="Enter your full name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="inputV2-base-inputRow addressFormUI-base-inputRow">
                                        <label htmlFor="mobile" className="input-label">Mobile Number *</label>
                                        <input
                                            className="inputV2-base-input"
                                            id="mobile"
                                            type="tel"
                                            placeholder="Enter your 10-digit mobile number"
                                            value={formData.mobile}
                                            onChange={handleInputChange}
                                            style={errorData.mobile ? { border: "1px solid red" } : { }}
                                        />
                                        {
                                            errorData.mobile
                                            &&
                                            <div className="error-address">Invalid Mobile Number</div>
                                        }
                                </div>

                                    <div className="addressFormUI-base-pincodeBlock">
                                        <div className="addressFormUI-base-inputContainer">
                                            <div className="inputV2-base-inputRow inputV2-base-top addressFormUI-base-inputRow">
                                                <label htmlFor="pincode" className="input-label">Pin Code *</label>
                                                <input
                                                    className="inputV2-base-input"
                                                    id="pincode"
                                                    type="tel"
                                                    placeholder="Enter 6-digit pin code"
                                                    value={formData.pincode}
                                                    onChange={handleInputChange}
                                                    style={errorData.pincode ? { border: "1px solid red" } : { }}
                                                />
                                                {
                                                    errorData.pincode
                                                    &&
                                                    <div className="error-address">Invalid Pincode</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inputV2-base-inputRow addressFormUI-base-inputRow">
                                        <label htmlFor="streetAddress" className="input-label">Street Address *</label>
                                        <input
                                            className="inputV2-base-input"
                                            id="streetAddress"
                                            type="text"
                                            placeholder="House No, Building, Street, Area"
                                            value={formData.streetAddress}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="addressFormUI-base-cityContainer">
                                        <div className="inputV2-base-inputRow addressFormUI-base-halfWidth inputV2-base-top addressFormUI-base-inputRow">
                                            <label htmlFor="city" className="input-label">City</label>
                                            <input
                                                className="inputV2-base-input"
                                                id="city"
                                                type="text"
                                                placeholder="Enter city name"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="inputV2-base-inputRow addressFormUI-base-halfWidth inputV2-base-top addressFormUI-base-inputRow">
                                            <label htmlFor="state" className="input-label">State</label>
                                            <input
                                                className="inputV2-base-input"
                                                id="state"
                                                type="text"
                                                placeholder="Enter state name"
                                                value={formData.state}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="addressFormUI-base-formHeader">SAVE ADDRESS AS</div>
                                <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
                                    <div className="addressFormUI-base-addressTypes">
                                        <div
                                            className={`addressFormUI-base-addressTypeIcon ${formData.addressType === "HOME"
                                                ? "addressFormUI-base-selectedAddressType"
                                                : ""
                                                }`}
                                            id="addressType-home"
                                            onClick={() => handleAddressTypeChange("HOME")}
                                            data-value="HOME"
                                        >
                                            Home
                                        </div>
                                        <div
                                            className={`addressFormUI-base-addressTypeIcon ${formData.addressType === "OFFICE"
                                                ? "addressFormUI-base-selectedAddressType"
                                                : ""
                                                }`}
                                            id="addressType-office"
                                            onClick={() => handleAddressTypeChange("OFFICE")}
                                            data-value="OFFICE"
                                        >
                                            Work
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
                                <div
                                    className="addressFormUI-base-isDefault"
                                    id="isDefault-icon"
                                    onClick={toggleDefaultAddress}
                                    data-value="undefined"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                    <span className="addressFormUI-base-defaultAddress">
                                        {formData.isDefault ? "This is your default address" : "Make this my default address"}
                                    </span>
                                </div>
                            </div> */}

                                <div className="addressFormUI-base-form addressDesktop-base-removeMargin">
                                    <div className="addressFormUI-base-isDefault" id="isDefault-icon">
                                        <input
                                            type="checkbox"
                                            id="isDefault"
                                            checked={formData.isDefault}
                                            onChange={toggleDefaultAddress}
                                        />
                                        <label htmlFor="isDefault" className="addressFormUI-base-defaultAddress">
                                            {formData.isDefault
                                                ? "This is your default address"
                                                : "Make this my default address"}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="addressFormUI-base-footer">
                                <button
                                    type="button"
                                    className="button-base-button addressFormUI-base-saveBtn button-base-textTransform"
                                    onClick={handleSubmit}
                                >
                                    {editingAddressId ? "SAVE ADDRESS" : "ADD ADDRESS"}
                                </button>
                                {editingAddressId && (
                                    <button
                                        type="button"
                                        className="address-form-delete-btn"
                                        onClick={openDeleteConfirmModal}
                                    >
                                        Delete address
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Standard confirmation modal: delete address */}
            {showDeleteConfirmModal && (
                <div className="confirm-modal-overlay" onClick={closeDeleteConfirmModal}>
                    <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="confirm-modal-header">
                            <h3>Delete address</h3>
                            <button type="button" className="confirm-modal-close" onClick={closeDeleteConfirmModal} disabled={deletingAddress} aria-label="Close">×</button>
                        </div>
                        <div className="confirm-modal-body">
                            <p>Are you sure you want to delete this address?</p>
                        </div>
                        <div className="confirm-modal-footer">
                            <button type="button" className="confirm-btn-secondary" onClick={closeDeleteConfirmModal} disabled={deletingAddress}>Cancel</button>
                            <button type="button" className="confirm-btn-danger" onClick={handleConfirmDeleteAddress} disabled={deletingAddress}>
                                {deletingAddress ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
